document.addEventListener('DOMContentLoaded', renderWishlist);

function renderWishlist() {
    const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    const container = document.getElementById('wishlist__container');
    const emptyMessage = document.querySelector('.wishlist__empty');
    const loader = document.getElementById('loader');
    const template = document.getElementById('wishlist-item-template').content;

    // Show the loader
    loader.style.display = 'block';

    // Clear the container before re-rendering
    container.innerHTML = '';

    if (wishlist.length === 0) {
        // container.innerHTML = '<p>Your wishlist is empty.</p>';
        emptyMessage.style.display = 'block';
        loader.style.display = 'none'; // Hide loader if wishlist is empty
    } else {
        emptyMessage.style.display = 'none';
        let itemsLoaded = 0; // Track loaded items

        wishlist.forEach(productId => {
            fetch(`/products/${productId}.js`)
                .then(response => response.json())
                .then(product => {
                    const productPrice = product.price / 100;
                    const formattedRate = theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, productPrice);

                    // Clone the template and populate it
                    const productNode = document.importNode(template, true);
                    if (!product.available){
                        productNode.querySelector('.wishlist__content.product-block').classList.add('product-block--unavailable');
                        productNode.querySelector('.quickbuy-container, .quickbuy-toggle').classList.add('wishlist__item--unavailable');
                    }
                    productNode.querySelector('.product-url').href = product.url;
                    productNode.querySelector('.quickbuy-toggle').href = product.url;
                    productNode.querySelector('.product-title').textContent = product.title;
                    productNode.querySelector('.product-image').src = product.images[0];
                    productNode.querySelector('.product-image').alt = product.title;
                    productNode.querySelector('.product-price').textContent = formattedRate;

                    // Set up the Remove button with a click event to remove the item dynamically
                    const removeButton = productNode.querySelector('.remove-btn');
                    removeButton.addEventListener('click', () => {
                        removeFromWishlist(productId);
                    });

                    // Append the populated template to the container
                    container.appendChild(productNode);

                    // Increment the loaded items counter and hide the loader if all items are loaded
                    itemsLoaded++;
                    if (itemsLoaded === wishlist.length) {
                        loader.style.display = 'none';
                    }
                });
        });
    }
}

function removeFromWishlist(productId) {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    wishlist = wishlist.filter(id => id !== productId);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    // Dispatch custom event to notify other scripts that the wishlist has been updated
    const event = new CustomEvent('wishlistUpdated', {
        detail: { wishlistLength: wishlist.length }
    });
    window.dispatchEvent(event);

    // Re-render the wishlist content to update the view
    renderWishlist();
}
